import React from 'react'
import NotificationCenterContext from './NotificationCenterContext'

export default function withNotificationCenter () {
    return (Component) => (props) => (
        <NotificationCenterContext.Consumer>
            {notification => <Component notificationCenter={notification} {...props} />}
        </NotificationCenterContext.Consumer>
    )
}